// extracted by mini-css-extract-plugin
export var reviews = "trustpilot-module--reviews--0a7dc";